// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useEffect, useState, useMemo, useContext} from 'react';
// @ts-ignore
import {createPortal} from 'react-dom';
import cn from 'classnames';
import {use_screen} from '../../hola/pub/lib/screen_util';
import {Settings_context} from '../../hola/pub/settings_ctx';

export interface i_modal_props_base {
    width: number;
    shadowless?: boolean;
    paddingless?: boolean;
    no_close?: boolean;
    no_bg?: boolean;
    no_modal_bg?: boolean;
    full_width?: boolean;
    no_animation?: boolean;
    content_when_open?: boolean;
    fix_height?: number;
    cls?: string;
    content_cls?: string;
    no_logo?: boolean;
    on_close_hdl?: ()=>boolean|undefined;
    low_dim?: boolean;
    lighter_close_btn?: boolean;
    mobile_full_height?: boolean
}
export interface i_modal_props extends i_modal_props_base {
    children?: React.ReactNode;
    is_open: boolean;
    on_close: ()=>void;
    on_overlay_click?: (ev: React.SyntheticEvent)=>void;
    portal?: boolean;
    fixed_top?: number;
    long_modal?: boolean;
}
export const Modal = (props:i_modal_props)=>{
    const {children, is_open, on_close, cls, width, shadowless, paddingless,
        no_bg, no_modal_bg, on_overlay_click, full_width, no_animation,
        no_logo, content_when_open, portal, content_cls, fixed_top,
        long_modal, low_dim, lighter_close_btn, mobile_full_height} = props;
    const [content_visible, set_content_visible] = useState(!content_when_open
        || content_when_open && is_open);
    const [was_open, set_was_open] = useState(false);
    const {theme} = useContext(Settings_context);
    const state = useMemo(()=>{
        if (!portal || !document.getElementById)
            return {el: null};
        const modal_root = document.getElementById('modal_root');
        if (!portal || !modal_root)
            return {el: null};
        const el = document.createElement('div');
        el.className = theme.root;
        modal_root.appendChild(el);
        return {el};
    }, []);
    useEffect(()=>{
        return ()=>{
            if (!state.el)
                return;
            const modal_root = document.getElementById('modal_root');
            modal_root.removeChild(state.el);
        };
    }, []);
    useEffect(()=>{
        if (is_open)
        {
            document.body.classList.add('hola_modal-no_body_scroll');
            document.documentElement.classList
                .add('hola_modal-no_body_scroll');
            set_was_open(true);
        }
        else
        {
            document.body.classList.remove('hola_modal-no_body_scroll');
            document.documentElement.classList
                .remove('hola_modal-no_body_scroll');
            if (was_open)
                setTimeout(()=>set_was_open(false), 300);
        }
        if (content_when_open)
        {
            if (is_open)
                set_content_visible(true);
            else
                setTimeout(()=>set_content_visible(false), 300);
        }
        return ()=>{
            document.body.classList.remove('hola_modal-no_body_scroll');
            document.documentElement.classList
                .remove('hola_modal-no_body_scroll');
        };
    }, [is_open]);
    const {height} = use_screen();
    const [css_vars, set_css_vars] = useState({} as any);
    useEffect(()=>{
        if (mobile_full_height && width <= 768)
            set_css_vars({'--app-height': '100%'});
        else
            set_css_vars({'--app-height': `${height}px`});
        if (fixed_top)
            set_css_vars({'--modal_top': `${fixed_top}px`});
    }, [height]);
    const show_content = content_visible || is_open;
    const rendered = <div onClick={on_overlay_click || on_close}
      style={css_vars}
      className={cn('hola_modal', cls,
      is_open && 'hola_modal--opened',
      !is_open && was_open && !no_animation && 'hola_modal--closing',
      paddingless && 'hola_modal--nopadding', no_bg && 'hola_modal--no_gb',
      full_width && 'hola_modal--full_width',
      fixed_top && 'hola_modal--fixed_top',
      !no_animation && 'hola_modal--with_animation',
      long_modal && 'hola_modal--long_modal',
      low_dim && 'hola_modal--low_dim')}>
      <div style={{width: `${width}px`}} className={cn('hola_modal-window',
        !shadowless && 'hola_modal-window--shadow',
        no_modal_bg && 'hola_modal-window--no_bg')}
        onClick={event=>event.stopPropagation()}>
        <div className={cn('hola_modal-content', content_cls,
          no_logo && 'hola_modal-content--no_logo')}>
          {show_content ? children : null}
        </div>
        {!props.no_close &&
          <span className={cn('hola_modal-close',
            lighter_close_btn && 'hola_modal-close--light_grey')}
            onClick={on_close}/>}
      </div>
    </div>;
    if (portal && state.el)
        return createPortal(rendered, state.el);
    return rendered;
};
